import { render, staticRenderFns } from "./promoCodeList.vue?vue&type=template&id=50634300"
import script from "./promoCodeList.vue?vue&type=script&lang=js"
export * from "./promoCodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports